import { useEffect, useState } from 'react';
import axios from 'axios';
import Main from '../../../component/Main.jsx';
import Loading from '../../../component/common/loading/Loading.jsx';
import MergedTableHeader from '../../../component/common/dataGrid/MergedTableHeader.jsx';
import ExcelDownload from '../../../component/common/button/ExcelDownload.jsx';

import { useDynamicStyle } from '../../../hooks/useDynamicStyle.js';
import * as Icons from '../../../images/icons/icons_component';

const CheckInfoList = () => {

    const [dataList, setDataList] = useState([]);
    const [isSearched, setIsSearched] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [searchParams, setSearchParams] = useState({
        searchGubunS: "4",
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };
    const dataHead = searchParams.searchGubunS === "4" ? ['지역', '전체기관수', '권역', '전문', '센터', '기관', '미참여 기관수', '미참여 응급의료 기관명'] : ['지역', '전체 지역응급의료기관', '참여 지역응급의료기관', '참여 응급의료기관명(환자분류소 사진 등록 여부)'];
    const dataColumn = searchParams.searchGubunS === "4" ? ['locaname', 'allcnt', 'cntA', 'cntB', 'cntC', 'cntD', 'noncnt', 'nonemog'] : ['locaname', 'cntD', 'noncnt', 'nonemog'];
    const apiCall = searchParams.searchGubunS === "4" ? '/ptmiapi/dashboard/check_infolist_searchList4.do' : '/ptmiapi/dashboard/check_infolist_searchList5.do';
    const excelFileName = searchParams.searchGubunS === "4" ? '표준등록체계점검표' : 'KTAS 전송참여(지역기관)';
    const excelHead = [];
    const mergeConfig = searchParams.searchGubunS === "4" ? [] : [{ key: 'locaname', row: null }, { key: 'cntD', row: null }, { key: 'noncnt', row: null }];

    const sum = (dataList, dataColumn) => {
        let array = ['합계'];
        let newDataColumn = dataColumn.slice(1, -1);

        newDataColumn.forEach(column => {
            let total = 0;
            const itemSet = new Set(dataList);
            itemSet.forEach(item => {
                const value = parseInt(item[column]);
                if (!isNaN(value)) {
                    total += value;
                }
            });
            array.push(total);
        });
        array.push('');
        return array;
    };

    const sum2 = (dataList, dataColumn) => {
        let array = ['합계'];
        let newDataColumn = dataColumn.slice(1, -1);

        const seenLocalnames = new Set();
        const uniqueDataList = dataList.filter(item => {
            if (seenLocalnames.has(item.locaname)) {
                return false;
            }
            seenLocalnames.add(item.locaname);
            return true;
        });

        newDataColumn.forEach(column => {
            let total = 0;
            uniqueDataList.forEach(item => {
                const value = parseInt(item[column]);
                if (!isNaN(value)) {
                    total += value;
                }
            });
            array.push(total);
        });

        array.push('');
        return array;
    };


    const fetchData = async () => {
        try {
            const response = await axios.get(apiCall,
                { params: searchParams }
            );
            setDataList(response.data);
            setIsSearched(true);
            setIsLoading(false);
        } catch (error) {
            console.error('데이터 로딩 중 오류 발생:', error);
        }
    };

    const search = () => {
        setIsSearched(true);
        setIsLoading(true);
        fetchData();
    };

    const computeRowSpans = (dataList, mergeConfig = [], allColumns = []) => {
        const rowSpans = dataList.map(() => ({}));
        let baseRowSpans = [];

        // 먼저 row가 null인 항목 중 첫 번째를 기준 병합으로 사용
        const firstMerge = mergeConfig.find(m => m.row == null);
        if (firstMerge) {
            const colKey = firstMerge.key;
            let prevValue = null;
            let startIndex = 0;
            let mergeCount = 1;
            baseRowSpans = new Array(dataList.length).fill(0);

            for (let i = 0; i < dataList.length; i++) {
                const currentValue = dataList[i][colKey];
                if (currentValue === prevValue && currentValue !== '') {
                    baseRowSpans[startIndex] += 1;
                    baseRowSpans[i] = 0;
                    mergeCount += 1;
                } else {
                    baseRowSpans[i] = 1;
                    startIndex = i;
                    mergeCount = 1;
                    prevValue = currentValue;
                }
            }

            // 모든 row === null인 항목에 동일하게 적용
            mergeConfig.forEach(({ key, row }) => {
                if (row == null) {
                    baseRowSpans.forEach((span, i) => {
                        rowSpans[i][key] = span;
                    });
                }
            });
        }

        // row가 지정된 항목은 독립적으로 병합 처리
        mergeConfig.forEach(({ key, row }) => {
            if (row != null) {
                for (let i = 0; i < dataList.length; i += row) {
                    const span = Math.min(row, dataList.length - i);
                    rowSpans[i][key] = span;
                    for (let j = 1; j < span; j++) {
                        if (i + j < dataList.length) {
                            rowSpans[i + j][key] = 0;
                        }
                    }
                }
            }
        });
        // 나머지 컬럼 기본 rowSpan 설정
        dataList.forEach((_, i) => {
            allColumns.forEach(colKey => {
                if (!(colKey in rowSpans[i])) {
                    rowSpans[i][colKey] = 1;
                }
            });
        });

        return rowSpans;
    };

    const rowSpans = computeRowSpans(dataList, mergeConfig ?? [], dataColumn);
    const colSpan = excelHead.length < 1 ? dataHead.length : excelHead.length;
    const totalValue = searchParams.searchGubunS === '4' ? sum(dataList, dataColumn) : sum2(dataList, dataColumn);

    useEffect(() => {
        setIsLoading(true);
        fetchData();
    }, [searchParams.searchGubunS]);

    // Dynamic Style Hook
    const { fontColor, primaryBackColor, lightBackColor, borderColorGray } = useDynamicStyle();

    return (
        <Main>
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="10%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>조회조건</th>
                            <td>
                                <select
                                    id="searchGubunS"
                                    name="searchGubunS"
                                    value={searchParams.searchGubunS}
                                    onChange={handleInputChange}
                                >
                                    <option value="4">표준등록체계점검표</option>
                                    <option value="5">KTAS 전송참여(지역기관)</option>
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className='search_btn_wrapper'>
                <span className='total_items'>전체&nbsp;<strong className={fontColor}>{dataList.length}</strong>건</span>
                <div className='btn_container'>
                    <button onClick={search} className={`search_btn ${primaryBackColor}`}><Icons.Search16w />검색</button>
                    <ExcelDownload
                        excelHead={dataHead}
                        excelData={dataList}
                        searched={isSearched}
                        dataCode={dataColumn}
                        excelFileName={excelFileName}
                        mergeData={mergeConfig}
                    />
                </div>
            </div>
            <div className='data_grid_container'>
                {isLoading ? <Loading /> :
                    <>
                        <hr className={`border-t-2 mr-1-1 ${borderColorGray}`}/>
                            <div className={`data_list_table ${isSearched ? 'grid-animation' : ''}`}>
                                <table>
                                    <MergedTableHeader
                                        headers={dataHead}
                                    />
                                    <tbody>
                                        {dataList.length === 0 ? (
                                            <tr>
                                                <td colSpan={colSpan}>
                                                    <span className={`data_empty ${lightBackColor}`}>
                                                        {isSearched ? <Icons.EmptyDalgu /> : <Icons.NullDalgu />}
                                                        {isSearched ? '해당하는 데이터가 없습니다.' : '검색 버튼을 눌러 데이터를 조회하세요.'}
                                                    </span>
                                                </td>
                                            </tr>
                                        ) : (
                                            <>
                                                {dataList.map((item, rowIndex) => {
                                                    const gridColor = rowIndex % 2 === 0 ? lightBackColor : '';
                                                    return (
                                                    <tr key={rowIndex} className={gridColor}>
                                                        {dataColumn.map((col, colIndex) => {
                                                            const span = rowSpans[rowIndex][col];
                                                            if (span) {
                                                                return (
                                                                    <td key={colIndex} rowSpan={span}>
                                                                        {item[col]}
                                                                    </td>
                                                                );
                                                            } else {
                                                                return null;
                                                            }
                                                        })}
                                                    </tr>
                                                )})}
                                                <tr className='sticky bottom-0 bg_st_row'>
                                                    {totalValue.map((value, index) => (
                                                        <td key={`sum-${index}`}><strong>{value}</strong></td>
                                                    ))}
                                                </tr>
                                            </>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <hr className='mr-1-1 co_border_gray'/>
                    </>
                }
            </div>
            <p className='mt-3'>* 표준진료정보 항목 중 '미상'으로 입력되어진 항목의 건수와 입력 비율을 표시합니다.<br />
                * 미상데이터 비율이 5%가 초과하지 않도록 관리해 주십시오.</p>
        </Main>
    )
}

export default CheckInfoList;